import React from "react";
import { Link } from "react-router-dom";

// Icons
import MicrophoneIcon from "../../../asset/images/home/icon/fi-rr-microphone-alt.png";
import LineIcon from "../../../asset/images/home/icon/line.png";
import CorrectIcon from "../../../asset/images/home/icon/correct.png";

// Student Images
import Student1 from "../../../asset/images/home/modules/1.png";
import Student2 from "../../../asset/images/home/modules/2.png";
import Student3 from "../../../asset/images/home/modules/3.png";
import Student4 from "../../../asset/images/home/modules/4.png";
import Student5 from "../../../asset/images/home/modules/5.png";

const SyllableStudentSpeak = () => {
    const letters = [
        { letter: "E", redDot: true },
        { letter: "X" },
        { letter: "T" },
        { letter: "R" },
        { letter: "A", redDot: true },
        { letter: "V" },
        { letter: "A", redDot: true },
        { letter: "G" },
        { letter: "A" },
        { letter: "N" },
        { letter: "T" },
    ];

    return (
        <div className="flex justify-center items-center min-h-screen">
            <main className="bg-white p-6 sm:p-8 w-full max-w-7xl">

                <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-gray-700">
                    Lesson 13: Decoding Multi-Syllabic words
                </h3>

                <h3 className="text-lg sm:text-xl font-bold text-gray-700 mb-3">
                    Virtual Class Demo
                </h3>

                <div className="border-l-2 border-gray-300 pl-4 text-gray-800 leading-relaxed mb-6 sm:text-left">
                    <p className="ml-2">
                        that you’ve learned how to teach students to learn the sounds of the alphabet,
                        let’s take this further by demonstrating with A.I. students. These are compliant
                        students that will repeat whatever you say. There is an expectation for a correct
                        response from you.
                    </p>
                </div>

                {/* Do Button */}
                <div className="flex justify-center mt-5 mb-5">
                    <button className="py-3 rounded-full bg-[#E2F2FF] hover:bg-[#c6e1f7] text-gray-700 font-medium mr-3 px-32 flex items-center justify-center">
                        <img src={MicrophoneIcon} height="20" width="20" className="mr-2" alt="" />
                        Students are speaking...
                    </button>
                </div>

                {/* Student Images */}
                <div className="flex justify-center gap-2 flex-wrap bg-[#E2F2FF] py-6 rounded-xl mb-8  border-4 border-primary">
                    <img src={Student1} alt="Student" className="w-50 h-50 object-cover" />
                    <img src={Student2} alt="Student" className="w-50 h-50 object-cover" />
                    <img src={Student3} alt="Student" className="w-50 h-50 object-cover" />
                    <img src={Student4} alt="Student" className="w-50 h-50 object-cover" />
                    <img src={Student5} alt="Student" className="w-50 h-50 object-cover" />
                </div>

                {/* Card Section */}
                <div className="max-w-7xl w-full">
                    <div className="relative bg-white rounded-xl shadow-lg p-8 md:p-16 border-2 border-[#439D55]">
                        {/* Tick Icon */}
                        <img src={CorrectIcon} alt="Correct" className="absolute top-4 right-4 w-8 h-8" />

                        <div className="text-center">
                            <h1 className="text-3xl md:text-4xl text-gray-800 mb-16">Extravagant</h1>

                            <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6">
                                {letters.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <div className="letter-box relative flex flex-col items-center">
                                            <button className="letter-btn border border-primary w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14
                        hover:bg-gray-300 text-black font-semibold rounded-lg transition-all duration-200
                        hover:-translate-y-1 flex items-center justify-center text-base sm:text-lg md:text-xl">
                                                {item.letter}
                                            </button>
                                            {item.redDot && <div className="red-dot absolute -top-2 -right-2 w-3 h-3 bg-red-500 rounded-full"></div>}
                                        </div>

                                        {/* Line icon between certain letters */}
                                        {[2, 4, 6].includes(index) && (
                                            <img src={LineIcon} alt="Down Arrow" className="down-arrow w-6 sm:w-8" />
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Navigation Button */}
                <div className="flex justify-center mt-5">
                    <Link to="/dashboard/modules/say-vowels">
                        <button className="px-8 py-3 rounded-full bg-green hover:bg-greenDark text-white font-medium">
                            Next →
                        </button>
                    </Link>
                </div>

            </main>
        </div>
    );
};

export default SyllableStudentSpeak;
